import React from "react";
import styled from "styled-components";
import moment from "moment";
import { Button, ButtonProps } from "@sonder/ui/source/styled/fragments/Button";
import { colors } from "@sonder/ui/source/styled/theme";
import {
  TaskUnitBookingInfoCurrentBooking,
  TaskUnitBookingInfoPreviousBooking,
  TaskUnitBookingInfoUpcomingBooking,
} from "core/queries/GetTask";

export enum TaskUnitBookingType {
  Default = "DEFAULT",
  Previous = "PREVIOUS",
  Current = "CURRENT",
  Upcoming = "UPCOMING",
}

export const TaskUnitBookingTypeLabels = {
  [TaskUnitBookingType.Default]: "",
  [TaskUnitBookingType.Previous]: "Previous",
  [TaskUnitBookingType.Current]: "Current",
  [TaskUnitBookingType.Upcoming]: "Upcoming",
};

interface StyledBookingTextProps {
  selected: boolean;
}

const StyledBookingText = styled.span<StyledBookingTextProps>`
  span {
    color: ${props => (props.selected ? colors.grayE : colors.grayA)};
    font-size: 0.875rem;
  }
`;

interface TaskBookingProps extends ButtonProps {
  booking:
    | TaskUnitBookingInfoPreviousBooking
    | TaskUnitBookingInfoCurrentBooking
    | TaskUnitBookingInfoUpcomingBooking;
  bookingLabel?: string;
}

export const TaskBooking = ({
  booking,
  bookingLabel = "",
  children,
  disabled,
  noBorder,
  onClick,
  selected = false,
}: TaskBookingProps) => {
  const firstName = booking?.account?.firstName || "";
  const lastInitial = (booking?.account?.lastName || "").slice(0, 1);
  const name = `${firstName} ${lastInitial}`.trim() || "";
  const checkInTime = booking?.checkInTime;
  const checkOutTime = booking?.checkOutTime;
  if (!checkInTime || !checkOutTime) {
    return null;
  }
  return (
    <Button
      fullWidth
      disabled={disabled}
      noBorder={noBorder}
      selected={selected}
      type="button"
      onClick={onClick}
    >
      <StyledBookingText selected={selected}>
        Notify {bookingLabel} Guest&nbsp;
        <span>
          ({name && `${name} - `}
          {moment(checkInTime).format("MMM. D")} -&nbsp;
          {moment(checkOutTime).format("MMM. D")})
        </span>
      </StyledBookingText>
      {children}
    </Button>
  );
};
